<div class="logo-container">
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 22 22"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    shape-rendering="crispEdges"
  >
    <g id="grid">
      <rect x="0" y="0" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="8" y="0" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="16" y="0" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="0" y="8" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="8" y="8" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="16" y="8" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="0" y="16" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="8" y="16" width="6" height="6" rx="1" class="logo-cell" />
      <rect x="16" y="16" width="6" height="6" rx="1" class="logo-cell" />
    </g>
  </svg>
</div>

<style lang="scss">
  .logo-container {
    display: inline-block;
  }
</style>
